import { AxiosResponse } from "axios";
import { all, call, put, takeEvery } from "redux-saga/effects";
import api from "../../api";
import Endpoint from "../../shared/endpoints";
import platformConstants from "../constants/platformConstants";

const getPlatforms = (payload: any) =>
  api.get(Endpoint.retrievePlatforms, {
    params: {
      ...(payload.clientId && { client: payload.clientId }),
      page: payload.page,
      ...(payload.pageSize && { page_size: payload.pageSize }),
      ...(payload.searchText && { search: payload.searchText }),
    },
  });
const createPlatform = (payload: any) =>
  api.post(Endpoint.createPlatform, payload);

const editPlatform = (id: string, payload: any) =>
  api.patch(`${Endpoint.editPlatform}/${id}/`, payload);

function* retrievePlatforms(action: any) {
  try {
    const response: AxiosResponse = yield call(getPlatforms, action.payload);
    yield put({
      type: platformConstants.GET_PLATFORMS_LIST_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: platformConstants.GET_PLATFORMS_LIST_FAILURE, err: e });
  }
}

function* createPlatformAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(createPlatform, action.payload);
    yield put({
      type: platformConstants.CREATE_PLATFORM_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: platformConstants.CREATE_PLATFORM_FAILURE, err: e });
  }
}

function* editPlatformAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(
      editPlatform,
      action.id,
      action.payload,
    );
    yield put({
      type: platformConstants.EDIT_PLATFORM_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: platformConstants.EDIT_PLATFORM_FAILURE, err: e });
  }
}

function* platformSaga() {
  yield all([
    takeEvery(platformConstants.GET_PLATFORMS_LIST, retrievePlatforms),
    takeEvery(platformConstants.CREATE_PLATFORM_REQUEST, createPlatformAsync),
    takeEvery(platformConstants.EDIT_PLATFORM_REQUEST, editPlatformAsync),
  ]);
}

export default platformSaga;
